import { useMutation } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value }) {
    let mutationResponse = await executeMutation({
      id: value.id,
    })

    if (mutationResponse.error) {
      return notify(
        notifyError(
          `There was a problem cancelling the appointment. Please try again.`
        )
      )
    }

    notify(notifySuccess(`The appointment was cancelled successfully.`))
    setFlowTo(normalizePath(props.viewPath, 'ConfirmationDialog/No'))
    if (typeof props.onActionComplete === 'function') props.onActionComplete()
  }
}
